import axios from "axios";
import environment from "../environments/environment";
import { toast } from "react-hot-toast";
import * as Yup from "yup";
export default class WitmatesServices {
   _services = ["Mobile App Development", "Design Development", "Web Development", "QA & Testing", "Enterprise Application", "Digital Marketing", "Staff Augmentation"];

   _requirements = ["Project Basis", "Staffing Needs"];

   _getInTouchValidationSchema = Yup.object().shape({
      email: Yup.string().email("Invalid email format").required("Email is required"),
      code: Yup.string().required("country code is required"),
      firstname: Yup.string().required("First name is required"),
      lastname: Yup.string().required("Last name is required"),
      message: Yup.string(),
      phone: Yup.string()
         .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
         .required("Phone number is required"),
      requirement_type: Yup.string().required("Requirement type is required"),
      services: Yup.string().required("Services is required"),
   });

   _applyJobSchema = Yup.object().shape({
      name: Yup.string().required("Name is required"),
      email: Yup.string().email("Invalid email format").required("Email is required"),
      experience: Yup.string()
         .matches(/^(?!0\d)\d{0,2}(\.\d{1,})?$/, "Experience should be example - 12 or 1.2")
         .required("Experience is required"),
      skill: Yup.string().required("Skill is required"),
      phone: Yup.string()
         .matches(/^\d{10}$/, "Phone number must be 10 digits")
         .required("Phone is required"),
   });

   _getQuoteTodaySchema = Yup.object().shape({
      name: Yup.string().required("First name is required"),
      email: Yup.string().email("Invalid email format").required("Email is required"),
      phone_number: Yup.string()
         .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
         .required("Phone number is required"),
      services: Yup.array().of(Yup.string().required("services is required")),
      requirement_type: Yup.string().required("Requirement type is required"),
   });
   constructor() {}
   //-------------------- aboutus api services ----------------------
   _getInTouchApi = async (body, callback) => {
      let headers = {
         "Content-Type": "multipart/form-data",
      };
      try {
         callback(true, null, null);
         let { data } = await axios.post(environment.baseurl + "/contacts", body, { headers });
         callback(false, data, null);
      } catch (error) {
         callback(false, null, error);
         toast.error("something went wrong!");
      }
   };
   //-------------------- career api services ----------------------
   _getJobsListApi = async (callback) => {
      try {
         callback(true, null, null);
         const data = await axios.get(environment.baseurl + "/jobs");
         callback(false, data, null);
      } catch (error) {
         callback(false, null, error);
      }
   };

   _applyJobApi = async (body, callback) => {
      try {
         let headers = {
            "Content-Type": "multipart/form-data",
         };
         callback(true, null, null);
         const data = await axios.post(environment.baseurl + "/applicants", body, {
            headers,
         });
         callback(false, data, null);
         //toast.success(data.data?.data?.message);
      } catch (error) {
         callback(false, null, error);
         toast.error("something went wrong!");
      }
   };

   //-------------------- email subscription api services ----------------------
   _subscribersApi = async (body, callback) => {
      try {
         let headers = {
            "Content-Type": "multipart/form-data",
         };
         callback(true, null, null);
         const data = await axios.post(environment.baseurl + "/subscribers", body, {
            headers,
         });
         callback(false, data, null);
         toast.success(data.data?.data?.message);
      } catch (error) {
         callback(false, null, error);
         toast.error("something went wrong!");
      }
   };
   //privete method  #getFlagEmoj #
   _getFlagEmoji = (countryCode) => {
      const codePoints = countryCode.toUpperCase().split("");
      const unicodeCodePoints = [];
      codePoints.forEach((char) => {
         const codePoint = 127397 + char.charCodeAt(0);
         unicodeCodePoints.push(codePoint);
      });
      return String.fromCodePoint(...unicodeCodePoints);
   };

   _allCountries = async (callback) => {
      try {
         callback(true, null, null);
         const { data } = await axios.get(`https://restcountries.com/v2/all`);
         console.log(data);
         const countries = data.map((country) => ({
            name: country.name,
            code: country.alpha2Code,
            std: country.callingCodes[0],
            icon: `https://flagcdn.com/${country.alpha2Code.toLowerCase()}.svg`,
         }));
         callback(false, countries, null);
      } catch (error) {
         callback(false, null, error);
      }
   };
}
